import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ModulePlaceholder.css';

interface ModulePlaceholderProps {
  title: string;
  icon: string;
  description: string;
}

const ModulePlaceholder: React.FC<ModulePlaceholderProps> = ({ title, icon, description }) => {
  const navigate = useNavigate();

  return (
    <div className="placeholder-container">
      <div className="placeholder-card">
        <div className="placeholder-icon">{icon}</div>
        <h2 className="placeholder-title">{title}</h2>
        <p className="placeholder-description">{description}</p>
        <span className="placeholder-badge">Yakında Hizmetinizde 🚀</span>
        <button className="placeholder-btn" onClick={() => navigate('/dashboard')}>
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default ModulePlaceholder;
